
<Button
  :class="computedClass"
  :type="type"
  :size="size"
  :variant="variant"
  :loading="loading"
  :disabled="disabled"
  :aria-disabled="disabled"
  :aria-busy="loading"
  @click.prevent="submitStep"
>
  {{ value }}
</Button>
